// import { IStatisticActionData, actionTypes, IStatisticState } from './types';
import initialState from './initial';
import { actionTypes } from './actions';

function reducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.ACTION_PROCESSING: {
      const actionProcessing = action.payload?.[actionTypes.ACTION_PROCESSING]?.actionProcessing;

      if (actionProcessing !== undefined) {
        return { ...state, actionProcessing };
      }
      return state;
    }

    case actionTypes.GET_STATISTIC: {
      const statistic = action.payload?.[actionTypes.GET_STATISTIC]?.statistic;

      if (statistic !== undefined)
        return {
          ...state,
          statistic,
        };
      return state;
    }

    default:
      return state;
  }
}

export default reducer;
